import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';
import { TokenStorageService } from './token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class OrdertemplateService { 
  baseUrl = environment.baseUrl;

  constructor(
    private router: Router, 
    private http: HttpClient, 
    private tokenStorage: TokenStorageService
  ) { }

  getOrdertemplate$(uuid: string, template_name: string): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.get<any>(url + 'order_item_templates?order_item_template_name=' + template_name + '&uuid=' + uuid);
  }

  modifyOrdertemplate$(uuid: string, orderInfo: any): Observable<any> {
    let url = `${this.baseUrl}${ApiPaths.orders}`;
    return this.http.post<any>(url + 'order_item_templates/bulk?uuid=' + uuid, orderInfo, httpOptions);
  }
  
}
